import { Button, ButtonProps, LinkProps } from "@mui/material"
import React from "react"

const BORDER_WIDTH = 2

export function ShimmerButton(props: ButtonProps & LinkProps) {
  return (
    <Button
      variant="text"
      sx={{
        "&::after": {
          filter: "blur(10px)",
        },
        "&::before, &::after": {
          animation: "steam 20s linear infinite",
          background:
            "linear-gradient(45deg, #fb0094, #0000ff, #00ff00, #ffff00, #ff0000, #fb0094, #0000ff, #00ff00, #ffff00, #ff0000)",
          backgroundSize: "400%",
          borderRadius: 10,
          content: '""',
          height: `calc(100% + ${BORDER_WIDTH * 2}px)`,
          left: `-${BORDER_WIDTH}px`,
          position: "absolute",
          top: `-${BORDER_WIDTH}px`,
          width: `calc(100% + ${BORDER_WIDTH * 2}px)`,
          zIndex: -1,
        },
        // define the animation
        "@keyframes steam": {
          "0%": { backgroundPosition: "0 0" },
          "100%": { backgroundPosition: "0 0" },
          "50%": { backgroundPosition: "400% 0" },
        },

        // background: "var(--mui-palette-background-default)",
        // color: "var(--mui-palette-text-primary)",
        background: "rgb(0, 0, 0, 0.8) !important",
        borderRadius: 10,
        color: "rgb(255, 255, 255)",
        gap: 0.5,
        maxHeight: 32,
        minWidth: 100,
        position: "relative",
        transform: "none !important",
      }}
      {...props}
    />
  )
}
